import { render, staticRenderFns } from "./CashboxDeleteOperation.vue?vue&type=template&id=56cb0745&"
import script from "./CashboxDeleteOperation.vue?vue&type=script&lang=js&"
export * from "./CashboxDeleteOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports